import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { Countdown } from '@swf/sports/components/Countdown/Countdown';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';
import { SportsLink } from '@swf/sports/components/SportsLink/SportsLink';
import { getRaceTimeFromRaceId } from '@swf/sports/utils/getRaceTimeFromRaceId';

import styles from './NextOff.scss';

const NextOff = () => {
  const race = useSelector(select.quickSwitcher.firstOffRace);
  const { eventTypeSlug, eventTypeId } = useSelector(
    (rootState: RootState) =>
      select.quickSwitcher.eventType(rootState, race?.eventTypeId) ?? {
        eventTypeSlug: '',
        eventTypeId: ''
      }
  );
  const { venueSlug } = useSelector(
    (rootState: RootState) =>
      select.quickSwitcher.meeting(rootState, race?.meetingId) ?? { venueSlug: '' }
  );

  if (!race) return null;

  const values = {
    eventTypeId,
    eventTypeSlug,
    venueSlug,
    meetingId: race.meetingId,
    raceId: getRaceTimeFromRaceId(race.raceId)
  };

  return (
    <SportsLink
      alias="sportsAnimalRacingRace"
      values={values}
      className={styles.nextOff}
      activeClassName={styles.nextOffActive}
    >
      <span className={styles.countdown}>
        <Countdown countdownDate={race.startTime} />
      </span>
      <span className={styles.info}>
        <FormattedDateTime date={race.startTime} /> - {race.venue}
      </span>
    </SportsLink>
  );
};

export default NextOff;
